import type { InvivoStandardPbrMaterialPlan } from "../../types/invivo_scene";

export function createStandardPbrMaterial({
  scene,
  materialPlan,
}: {
  scene: unknown;
  materialPlan: InvivoStandardPbrMaterialPlan;
}): unknown {
  const { BABYLON } = window;
  const material = new BABYLON.PBRMetallicRoughnessMaterial(`Invivo::material::${materialPlan.name}`, scene);

  material.baseColor = BABYLON.Color3.FromHexString(materialPlan.baseColor);
  material.metallic = materialPlan.metallic;
  material.roughness = materialPlan.roughness;
  material.alpha = materialPlan.alpha;
  material.backFaceCulling = materialPlan.backFaceCulling;
  const opaqueMode = BABYLON.PBRMetallicRoughnessMaterial.PBRMATERIAL_OPAQUE ?? 0;
  const alphaBlendMode = BABYLON.PBRMetallicRoughnessMaterial.PBRMATERIAL_ALPHABLEND ?? 2;
  material.transparencyMode =
    materialPlan.transparencyMode === "alpha_blend" || materialPlan.alpha < 1 ? alphaBlendMode : opaqueMode;
  material.useRoughnessFromMetallicTextureGreen = materialPlan.roughnessTextureChannel !== "red";
  material.useRoughnessFromMetallicTextureRed = materialPlan.roughnessTextureChannel === "red";
  material.useMetallnessFromMetallicTextureBlue = materialPlan.metallicTextureChannel !== "green";
  material.useMetalnessFromMetallicTextureBlue = materialPlan.metallicTextureChannel !== "green";
  material.useMetallnessFromMetallicTextureGreen = materialPlan.metallicTextureChannel === "green";
  material.useMetalnessFromMetallicTextureGreen = materialPlan.metallicTextureChannel === "green";
  material.useAmbientInGrayScale = materialPlan.useAmbientInGrayScale ?? true;
  material.useAlphaFromAlbedoTexture = materialPlan.useAlphaFromAlbedoTexture ?? false;

  if (materialPlan.baseTextureUrl) {
    material.baseTexture = new BABYLON.Texture(materialPlan.baseTextureUrl, scene, false, false);
  }

  if (materialPlan.normalTextureUrl) {
    material.normalTexture = new BABYLON.Texture(materialPlan.normalTextureUrl, scene, false, false);
  }

  if (materialPlan.metallicRoughnessTextureUrl) {
    material.metallicRoughnessTexture = new BABYLON.Texture(
      materialPlan.metallicRoughnessTextureUrl,
      scene,
      false,
      false
    );
  }

  if (materialPlan.occlusionTextureUrl) {
    material.occlusionTexture = new BABYLON.Texture(materialPlan.occlusionTextureUrl, scene, false, false);
    material.ambientTexture = material.occlusionTexture;
  }

  return material;
}
